
import axios from "axios";
import { clearLocalStorageData, getLocalStorageData } from "../shared/commonFunction";
import { showToast } from "../shared/sharedComponents/ToasterMessage/ToasterMessage";

const BASE_URL = import.meta.env.VITE_API_URL;
const API_KEY = import.meta.env.VITE_API_KEY

// Reusable axios client
const apiClient = axios.create({
    baseURL: BASE_URL,
    timeout: 15000,
});

/**
 * Centralized API error handler
 */
const handleApiError = (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || "Something went wrong";

    switch (status) {
        case 400:
            showToast(message, "error");
            break;

        case 401:
            showToast(message, "error");
            clearLocalStorageData();
            setTimeout(() => {
                window.location.replace("/login");
            }, 800);
            break;

        case 403:
            showToast("Access denied.", "error");
            break;

        case 500:
            showToast("Server error. Please try again later.", "error");
            break;

        default:
            showToast(message, "error");
    }

    throw error;
};

/**
 * Generic PUT API Request
 * @param {string} endpoint - API endpoint
 * @param {object} data - Request body
 * @returns {Promise<any>}
 */
export const putApiRequest = async (endpoint, data) => {
    try {
        const token = getLocalStorageData("token");
        const selectedLanguage = getLocalStorageData("language") || "ar";

        const response = await apiClient.put(endpoint, data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: token ? `Bearer ${token}` : "",
                "Accept-Language": selectedLanguage,
                "X-API-Key": API_KEY
            },
        });

        return response?.data;
    } catch (error) {
        handleApiError(error);
    }
};
